module.exports = __webpack_public_path__ + "img/share_guide.f119793b.png";